// extracted by mini-css-extract-plugin
module.exports = {"loading":"ButtonLoader_loading__1g9mp"};